'use client';

import Link from 'next/link';
import { getBrandHomeUrl } from '@/lib/creatorPlatformUrls';

export default function NotFound() {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      padding: '2rem',
      textAlign: 'center'
    }}>
      <h1 style={{
        fontSize: '6rem',
        fontWeight: '700',
        color: '#3b82f6',
        margin: '0',
        lineHeight: '1'
      }}>
        404
      </h1>
      
      <h2 style={{
        fontSize: '1.5rem',
        fontWeight: '600',
        marginBottom: '1rem',
        color: '#1f2937'
      }}>
        页面未找到
      </h2>
      
      <p style={{
        fontSize: '1rem',
        color: '#6b7280',
        marginBottom: '2rem',
        maxWidth: '500px'
      }}>
        抱歉，您访问的页面不存在。请检查URL是否正确，或返回首页。
      </p>
      
      <div style={{
        display: 'flex',
        gap: '1rem'
      }}>
        <Link
          href={getBrandHomeUrl()}
          style={{
            padding: '0.75rem 1.5rem',
            backgroundColor: '#3b82f6',
            color: '#ffffff',
            border: 'none',
            borderRadius: '0.375rem',
            fontSize: '1rem',
            fontWeight: '500',
            cursor: 'pointer',
            textDecoration: 'none',
            transition: 'background-color 0.2s ease'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#2563eb';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = '#3b82f6';
          }}
        >
          返回首页
        </Link>
        
        <button
          onClick={() => window.history.back()}
          style={{
            padding: '0.75rem 1.5rem',
            backgroundColor: '#f3f4f6',
            color: '#374151',
            border: '1px solid #d1d5db',
            borderRadius: '0.375rem',
            fontSize: '1rem',
            fontWeight: '500',
            cursor: 'pointer',
            transition: 'background-color 0.2s ease'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#e5e7eb';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = '#f3f4f6';
          }}
        >
          返回上页
        </button>
      </div>
    </div>
  );
}
